import React from 'react';
import { WppProgressIndicator, WppTypography } from 'buildingBlocks';
import { PIXEL_PICKER_STYLES } from './styles';

const { loadingIndicator, loadingTextMessage } = PIXEL_PICKER_STYLES;

const PixelsLoading = () => (
  <>
    <WppProgressIndicator variant="circle" width={25} style={loadingIndicator} />
    <WppTypography type="s-body" tag="p" style={loadingTextMessage}>
      Loading pixels, please wait
    </WppTypography>
  </>
);

export default PixelsLoading;
